import { useState } from "react";
import { SETTINGS_BODY_DIV } from "../../../../assets/styles/classes-constants";
import { BodyDiv } from "../../../../components/components-style";
import { CaptionText, MediumText } from "../../../../components/typography";
import Input from "../../../../components/ui/inputs";
import { Block } from "../../main";
import { CheckboxInput } from "../../../../components/ui/checkbox";
import { COLORS } from "../../../../assets/utils/enums/colors";
import { Button } from "../../../../components/ui/button";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useFormValidation } from "../../../../assets/utils/hooks/useFormsValidation";
import { validateAddMemberTeam } from "../../../../assets/utils/validation/form/validator-add-member-team";
import toast from "react-hot-toast";
import CustomToast from "../../../../components/ui/custom-toast";
import { ToastTypeEnum } from "../../../../assets/utils/enums/toast";
import { ValidationFormsModeEnum } from "../../../../assets/utils/validation/form/types";

type ProfileOutletContext = {
    setLoaderState: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function AddMemberTeam() {
    const { setLoaderState } = useOutletContext<ProfileOutletContext>();

    const [firstName, setFirstName] = useState<string>("");
    const [lastName, setLastName] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [isSendInvite, setIsSendInvite] = useState<boolean>(false);

    const { errors, validate } = useFormValidation(validateAddMemberTeam);
    const navigate = useNavigate();

    const handleSave = async () => {
        try {
            setLoaderState(true);

            const { hasErrors } = validate(
                {
                    firstName, lastName, email
                },
                ValidationFormsModeEnum.ADD
            );

            if (hasErrors) return;

            //   const response = await authFetch(`${API_URL_TASK}/create-task`, {
            //     method: "POST",
            //     headers: { "Content-Type": "application/json" },
            //     body: JSON.stringify({
            //       name: name,
            //       description: description,
            //       deadline: formatIOS(deadline),
            //       projectId: project.name === "" ? null : project.id,
            //       sellingId: selling.name === "" ? null : selling.id,
            //       priorityName: priority,
            //       users: members
            //         .filter((item) => item.email.trim() !== "")
            //         .map((item) => ({ email: item.email })),
            //     }),
            //     credentials: "include",
            //   });

            //   if (!response.ok) {
            //     toast((t) => (
            //       <CustomToast
            //         t={t}
            //         type={ToastTypeEnum.WARNING}
            //         text={"Перевірте коректність введення даних!"}
            //       />
            //     ));
            //     return;
            //   }
            toast((t) => (
                <CustomToast
                    t={t}
                    type={ToastTypeEnum.SUCCESS}
                    text={"Дані введені коректно, учасника додано додано!"}
                />
            ));
            setTimeout(() => {
                navigate("/settings/team/view");
            }, 300);
        } catch (error) {
            console.error("Fetch error:", error);
            toast((t) => (
                <CustomToast
                    t={t}
                    text={"Упс, щось пішло не так\nПроблема з сервером."}
                    type={ToastTypeEnum.ERROR}
                />
            ));
        } finally {
            setTimeout(() => {
                setLoaderState(false);
            }, 150);
        }
    };

    return (
        <BodyDiv
            className={`${SETTINGS_BODY_DIV} justify-content-between gap-4`}
            $isPadding={true}
        >
            <Block
                className={`w-100 d-flex flex-column align-items-center gap-2`}
            >
                <CaptionText>Додати користувача у команду</CaptionText>
                <div className="w-100">
                    <span className="w-100 d-flex gap-sm-3 flex-sm-row flex-column">
                        <Input
                            attribute="firstName"
                            value={firstName}
                            setValue={setFirstName}
                            errorText={errors.firstName}
                            label="Ім’я"
                            placeholder="Введіть ім’я"
                        />
                        <Input
                            attribute="lastName"
                            value={lastName}
                            setValue={setLastName}
                            errorText={errors.lastName}
                            label="Прізвище"
                            placeholder="Введіть прізвище"
                        />
                    </span>
                    <Input
                        attribute="email"
                        value={email}
                        setValue={setEmail}
                        errorText={errors.email}
                        label="Електронна пошта"
                        placeholder="Example@gmail.com"
                    />
                    <Input
                        attribute="description"
                        value={description}
                        setValue={setDescription}
                        errorText={""}
                        label="Опис"
                        placeholder="Напишіть трішки інформації про учасника"
                    />
                    <div className="p-2">
                        <CheckboxInput
                            text="Відправити запрошення на пошту"
                            state={isSendInvite}
                            setState={setIsSendInvite}
                        />
                    </div>
                </div>
            </Block>
            <Block
                className={`w-100 d-flex align-items-start justify-content-between`}
            >
                <Button
                    bgcolor={COLORS.gray}
                    txtcolor={COLORS.secondary1}
                    brcolor={COLORS["bg-text-color"]}
                    type="large"
                    width="49%"
                    className="d-flex align-items-center gap-2"
                    onClick={() => {
                        navigate(-1);
                    }}
                >
                    <MediumText>Скасувати</MediumText>
                </Button>
                <Button
                    bgcolor={COLORS.secondary1}
                    txtcolor={COLORS.white}
                    brcolor={COLORS.secondary1}
                    type="large"
                    width="49%"
                    className="d-flex align-items-center gap-2"
                    onClick={handleSave}
                >
                    <MediumText>{isSendInvite ? "Додати та запросити" : "Додати"}</MediumText>
                </Button>
            </Block>
        </BodyDiv>
    )
}